import _get from "lodash/get"
import { aemAxiosInstance } from "@/constants/api"
import { GLOBAL_CONFIGURATION_ENDPOINT } from "@/constants"
import {
  getOpenOrders,
  getPastOrders,
  findOrderByEmail,
  findOrderByOrderID,
} from "@/store/features/orderSlice"
import { store } from "@/store"

export const getCardDetails = async ({ url, cardId }) => {
  try {
    const serviceList = await aemAxiosInstance({
      url: GLOBAL_CONFIGURATION_ENDPOINT,
      params: {
        path: url,
      },
    })
    if (serviceList?.data?.cardTypes) {
      const cardTypesList = await aemAxiosInstance({
        url: GLOBAL_CONFIGURATION_ENDPOINT,
        params: {
          path: serviceList?.data?.cardTypes,
        },
      })
      if (cardTypesList && cardTypesList.data) {
        const cardValueText =
          cardTypesList?.data?.find(card => card.value === cardId)?.text ?? ""
        return cardValueText
      } else {
        // log.error(
        //   "Card Details: Error occured while fetching data from AEM"
        // )
      }
    }
  } catch (error) {
    // log.error(error)
  }
}

export const setMenu = (info, i18n) => {
  const {
    accountSettingsPath,
    myFavoritesPagePath,
    orderHistoryPath,
    // myProductsPath,    commenting the code as we have to hide myproduct and myservices
    // myServicesPath,
  } = info
  const data = [
    {
      title: i18n.accountSettings,
      url: accountSettingsPath,
    },
    {
      title: i18n.favorites,
      url: myFavoritesPagePath,
    },
    {
      title: i18n.orders,
      url: orderHistoryPath,
    },
    // {
    //   title: i18n.myProducts,
    //   url: myProductsPath,
    // },
    // {
    //   title: i18n.myServices,
    //   url: myServicesPath,
    // },
  ]
  return data
}

export const fetchOrders = async (
  offset = 0,
  fetchOpen = true,
  fetchPast = true
) => {
  // #ToDo Make loading true
  const openOrders = []
  const pastOrders = []
  let openOrdersTotal = 0
  let pastOrdersTotal = 0
  if (fetchOpen) {
    const { total, results: openData } = await store
      .dispatch(getOpenOrders(offset))
      .unwrap()
      .then(response => response)
    openOrdersTotal = total
    openData.forEach(order => {
      const orderDate = new Date(_get(order, "createdAt", ""))
      let openDataArr = order.lineItems?.filter(
        item =>
          !item.variant?.attributes?.find(attr => attr.name === "ComboSKU")
      )
      if (order?.custom?.fields?.isImported) {
        openDataArr = [
          ...openDataArr,
          ...order?.customLineItems?.filter(
            item =>
              !item.variant?.attributes?.find(attr => attr.name === "ComboSKU")
          ),
        ]
      }
      openOrders.push({
        orderNo: _get(order, "orderNumber", ""),
        totalItems: openDataArr.reduce((a, b) => {
          return a + b.quantity
        }, 0),
        orderStatus: _get(order, "state.obj.name.en", ""),
        orderDate: `${orderDate.toLocaleString("default", {
          month: "long",
        })} ${orderDate.getDate()}, ${orderDate.getFullYear()}`,
        orderTotal: Number(
          _get(order, "taxedPrice.totalGross.centAmount", 0) / 100
        ).toFixed(2),
        isImported: _get(order, "custom.fields.isImported", false),
        migratedOrderDate: _get(order, "custom.fields.orderCreatedAt", ""),
      })
    })
  }
  if (fetchPast) {
    const { total, results: pastData } = await store
      .dispatch(getPastOrders(offset))
      .unwrap()
      .then(response => response)
    pastOrdersTotal = total
    pastData.forEach(order => {
      const orderDate = new Date(_get(order, "createdAt", ""))
      let pastDataArr = order.lineItems?.filter(
        item =>
          !item.variant?.attributes?.find(attr => attr.name === "ComboSKU")
      )
      if (order?.custom?.fields?.isImported) {
        pastDataArr = [
          ...pastDataArr,
          ...order?.customLineItems?.filter(
            item =>
              !item.variant?.attributes?.find(attr => attr.name === "ComboSKU")
          ),
        ]
      }
      pastOrders.push({
        orderNo: _get(order, "orderNumber", ""),
        totalItems: pastDataArr.reduce((a, b) => {
          return a + b.quantity
        }, 0),
        orderStatus: _get(order, "state.obj.name.en", ""),
        orderDate: `${orderDate.toLocaleString("default", {
          month: "long",
        })} ${orderDate.getDate()}, ${orderDate.getFullYear()}`,
        orderTotal: Number(
          _get(order, "taxedPrice.totalGross.centAmount", 0) / 100
        ).toFixed(2),
        isImported: _get(order, "custom.fields.isImported", false),
        migratedOrderDate: _get(order, "custom.fields.orderCreatedAt", ""),
      })
    })
  }
  return { openOrders, openOrdersTotal, pastOrders, pastOrdersTotal }
}

export const fetchOrderDataByEmailOrderId = async (
  email,
  orderNo,
  source = ""
) => {
  return await store
    .dispatch(findOrderByEmail({ orderNo, email, source }))
    .unwrap()
    .then(response => response)
}

export const fetchOrderDataByOrderId = async orderNo => {
  return await store
    .dispatch(findOrderByOrderID({ orderNo }))
    .unwrap()
    .then(response => response)
}

export * from "../src/utils/orders"
